module.exports = __webpack_public_path__ + "img/e37a77b.png";